import React from 'react';
import '../CSS/People.css';
import { TeamList } from '../components/TeamList';
import { AdvisorList } from '../components/AdvisorList';
import PopUp from '../components/Popup';
// import BarLoader from 'react-spinners/ClipLoader';
// import { CSSRef } from '../components/CSSRef';



class People extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: 0,
      popup: false,
      popupname: '',
      popupObj: {},
      // isLoading: true,
    };
  }

  componentDidMount() {
    this.setState({ clicked: 0 });
    window.scrollTo(0, 0);

  }

  handleBtnClick = (id) => {
    this.setState({ clicked: id });
  }

  togglePopUp = (obj) => {
    this.setState({ popupObj: obj, popup: !this.state.popup });
  }

  member = (item) => {
    const icon = <img src={item.icon} alt='' />;
    return (
      <div className='member-container' key={item.name}>
        <button onClick={() => this.togglePopUp(item)} key={item.name} className='member' >
          {item.icon !== '' ? icon : <img src={process.env.PUBLIC_URL + '/assets/IMG_2477.jpg'} alt='' />}
          <div className='overlay'>
            <div className='overlay-text'>{item.role}</div>
          </div>
        </button>
        <div className='people-name'>{item.name}</div>
      </div>


    )
  }

  render() {
    return (
      <div className='people'>
        {/* {this.state.isLoading ? <div className='load-container'><BarLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={CSSRef} /></div> : null} */}
        {this.state.popup ? <PopUp toggle={this.togglePopUp} member={this.state.popupObj} /> : null}

        <div className='banner' style={{ paddingTop: '100px' }}>
          <button onClick={() => this.handleBtnClick(0)} ><h1 id={'Team'}> Team</h1></button>

          <div className='deptbtns'>
            <button onClick={() => this.handleBtnClick(1)}>WET LAB</button>
            <button onClick={() => this.handleBtnClick(2)}>DRY LAB</button>
            <button onClick={() => this.handleBtnClick(3)}>SCI COMM</button>
          </div>
        </div>
        <div className='teamlist'>
          {
            TeamList.map((item, index) => {

              if (this.state.clicked === 0) {
                return (
                  <>
                    {this.member(item)}
                  </>

                )
              }
              else if (this.state.clicked === item.dept) {
                return (
                  <>
                    {this.member(item)}
                  </>
                )
              }
              else {
                return (<></>)
              }
            })
          }
        </div>
        <div className='banner'>
          <h1 id={'PI'}>Advisors and Investigators</h1>
        </div>
        <div className='teamlist'>
          {
            AdvisorList.map((item, index) => {

              return (
                <>
                  {this.member(item)}
                </>

              )
            })
          }
        </div>
      </div>
    );
  }
}


export default People;
